/**
 * Authentication state store (Zustand).
 * Manages JWT tokens, user info, and session state.
 * Shared across all projects using @ipsoftsrl/frontend-auth.
 */
import { create } from 'zustand';
export const useAuthStore = create((set) => ({
    isAuthenticated: false,
    mfaConfigured: null,
    user: null,
    accessToken: null,
    idToken: null,
    refreshToken: null,
    setAuthenticated: (tokens, user) => set({
        isAuthenticated: true,
        user,
        accessToken: tokens.accessToken,
        idToken: tokens.idToken,
        refreshToken: tokens.refreshToken,
    }),
    setMfaConfigured: (configured) => set({ mfaConfigured: configured }),
    logout: () => set({
        isAuthenticated: false,
        mfaConfigured: null,
        user: null,
        accessToken: null,
        idToken: null,
        refreshToken: null,
    }),
    setTokens: (accessToken, idToken) => set({ accessToken, idToken }),
}));
//# sourceMappingURL=store.js.map